const React = require("react");

function ShoppingBagIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
  }));
}

module.exports = ShoppingBagIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/ShoppingBagIcon.js
 ** module id = 611
 ** module chunks = 0
 **/